
import { createSelector }                 from 'reselect';
import {
    MessageTemplatesContainerProps,
    MessageTemplate
}                                         from './MessageTemplatesListTypes';

const getTemplatesData = (data, props) => data;
const getCustomerName = (data, props: MessageTemplatesContainerProps) => props.recipient.name;

const customerNameRegex = /(\s){{customerName}}/g;

const filterFields = ({ name }) => name !== 'customerName';

// FIXME: instead of doing this on the frontend, we should pass a flag and filter on the backend
function clearCustomerNamePattern(currentTemplate: MessageTemplate): MessageTemplate {
    const messageString  = currentTemplate.template.message.replace(customerNameRegex, '');
    const filteredFields = currentTemplate.template.fields.filter(filterFields);

    return {
        ...currentTemplate,
        template: {
            ...currentTemplate.template,
            fields: filteredFields,
            message: messageString
        }
    };
}

export const getFilteredTemplates = createSelector(
    [getTemplatesData, getCustomerName],
    (messageTemplatesData, customerName: string | void) => {
        if (!messageTemplatesData.messageTemplates || !messageTemplatesData.messageTemplates.templates.length) {
            return messageTemplatesData;
        }

        return {
            ...messageTemplatesData,
            messageTemplates: {
                ...messageTemplatesData.messageTemplates,
                templates: customerName ? messageTemplatesData.messageTemplates.templates : messageTemplatesData.messageTemplates.templates.map(clearCustomerNamePattern)
            }
        };
    }
);



// WEBPACK FOOTER //
// ./src/sections/MessageTemplatesList/MessageTemplatesListSelector.ts